import { ConectoresTarefas, ConectoresTarefaCadastro } from '@containers';
import { InfoUsuario } from '@utils';

const getPermissaoFila = (infoUsuario) => InfoUsuario.perm('admin') || InfoUsuario.perm('fila');

export default [
  {
    path: '/conectores/configuracao/:idConfiguracao/fonte/dado/:idFonteDado/tarefas',
    text: 'Tarefa',
    component: ConectoresTarefas,
    secret: true,
    exact: true,
    permissions: (infoUsuario) => getPermissaoFila(infoUsuario),
  },
  {
    path: '/conectores/configuracao/:idConfiguracao/fonte/dado/:idFonteDado/tarefa/:id',
    text: 'Tarefa',
    component: ConectoresTarefaCadastro,
    secret: true,
    exact: true,
    permissions: (infoUsuario) => getPermissaoFila(infoUsuario),
  },
];
